// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
  urlSearchParamsBodySerializer,
} from './client';
import { client } from './client.gen';
import type {
  DocumentIsReadyData,
  DocumentIsReadyErrors,
  DocumentIsReadyResponses,
  GlacierAgenciesApiListWritingCompanyData,
  GlacierAgenciesApiListWritingCompanyResponses,
  GlacierAssistantApiAssistantConfigData,
  GlacierAssistantApiAssistantConfigResponses,
  GlacierAssistantApiChatData,
  GlacierAssistantApiChatResponses,
  GlacierAssistantApiSubmitFeedbackData,
  GlacierAssistantApiSubmitFeedbackResponses,
  GlacierAuthenticationApiMfaVerifyData,
  GlacierAuthenticationApiMfaVerifyResponses,
  GlacierNewGradApiDownloadPolicyData,
  GlacierNewGradApiDownloadPolicyResponses,
  GlacierNewGradApiDownloadQuoteData,
  GlacierNewGradApiDownloadQuoteResponses,
  GlacierNewGradApiGetAnswersData,
  GlacierNewGradApiGetAnswersResponses,
  GlacierNewGradApiIssuePolicyData,
  GlacierNewGradApiIssuePolicyErrors,
  GlacierNewGradApiIssuePolicyResponses,
  GlacierNewGradApiMarkPaymentAsPaidData,
  GlacierNewGradApiMarkPaymentAsPaidResponses,
  GlacierNewGradApiPollPaymentData,
  GlacierNewGradApiPollPaymentResponses,
  GlacierNewGradApiSaveAnswersData,
  GlacierNewGradApiSaveAnswersErrors,
  GlacierNewGradApiSaveAnswersResponses,
  GlacierNewGradApiValidateAgencyData,
  GlacierNewGradApiValidateAgencyErrors,
  GlacierNewGradApiValidateAgencyResponses,
  GlacierNewGradApiValidateAssociationCodeData,
  GlacierNewGradApiValidateAssociationCodeErrors,
  GlacierNewGradApiValidateAssociationCodeResponses,
  GlacierOfacApiOfacDecideData,
  GlacierOfacApiOfacDecideErrors,
  GlacierOfacApiOfacDecideResponses,
  GlacierOfacApiOfacEntityDetailData,
  GlacierOfacApiOfacEntityDetailErrors,
  GlacierOfacApiOfacEntityDetailResponses,
  GlacierOfacApiOfacReviewData,
  GlacierOfacApiOfacReviewErrors,
  GlacierOfacApiOfacReviewResponses,
  GlacierOneschemaApiBulkUploadDentistsData,
  GlacierOneschemaApiBulkUploadDentistsErrors,
  GlacierOneschemaApiBulkUploadDentistsResponses,
  GlacierOneschemaApiBulkUploadLocationsData,
  GlacierOneschemaApiBulkUploadLocationsErrors,
  GlacierOneschemaApiBulkUploadLocationsResponses,
  GlacierOneschemaApiBulkUploadPoliciesData,
  GlacierOneschemaApiBulkUploadPoliciesErrors,
  GlacierOneschemaApiBulkUploadPoliciesResponses,
  GlacierOneschemaApiGetJwtTokenData,
  GlacierOneschemaApiGetJwtTokenErrors,
  GlacierOneschemaApiGetJwtTokenResponses,
  GlacierPolicyApiAcknowledgePolicyAlertData,
  GlacierPolicyApiAcknowledgePolicyAlertResponses,
  GlacierPolicyApiAddCommercialPropertyCoverageData,
  GlacierPolicyApiAddCommercialPropertyCoverageResponses,
  GlacierPolicyApiAddDentistData,
  GlacierPolicyApiAddDentistResponses,
  GlacierPolicyApiAddLocationData,
  GlacierPolicyApiAddLocationResponses,
  GlacierPolicyApiAgencyBillInvoiceData,
  GlacierPolicyApiAgencyBillInvoiceResponses,
  GlacierPolicyApiAssignableData,
  GlacierPolicyApiAssignableResponses,
  GlacierPolicyApiAssignAgentData,
  GlacierPolicyApiAssignAgentResponses,
  GlacierPolicyApiAssignData,
  GlacierPolicyApiAssignResponses,
  GlacierPolicyApiAssignUnderwriterData,
  GlacierPolicyApiAssignUnderwriterResponses,
  GlacierPolicyApiBulkUpdateLocationsData,
  GlacierPolicyApiBulkUpdateLocationsResponses,
  GlacierPolicyApiCancelMidtermChangeData,
  GlacierPolicyApiCancelMidtermChangeResponses,
  GlacierPolicyApiChangeEndorsementEffectiveDateData,
  GlacierPolicyApiChangeEndorsementEffectiveDateResponses,
  GlacierPolicyApiClearDentistTruthmdData,
  GlacierPolicyApiClearDentistTruthmdResponses,
  GlacierPolicyApiCloseRenewalData,
  GlacierPolicyApiCloseRenewalResponses,
  GlacierPolicyApiCommitTransactionTestData,
  GlacierPolicyApiCommitTransactionTestResponses,
  GlacierPolicyApiConditionalRenewalNoticeData,
  GlacierPolicyApiConditionalRenewalNoticeResponses,
  GlacierPolicyApiConfirmRatingChecksData,
  GlacierPolicyApiConfirmRatingChecksResponses,
  GlacierPolicyApiCreateMidtermTransactionData,
  GlacierPolicyApiCreateMidtermTransactionResponses,
  GlacierPolicyApiCreateOwnedEntitiesData,
  GlacierPolicyApiCreateOwnedEntitiesResponses,
  GlacierPolicyApiCreatePolicyData,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponses,
  GlacierPolicyApiCreatePolicyResponses,
  GlacierPolicyApiCreateRenewalData,
  GlacierPolicyApiCreateRenewalResponses,
  GlacierPolicyApiCreateUnderwriterNotesData,
  GlacierPolicyApiCreateUnderwriterNotesResponses,
  GlacierPolicyApiDeclineTransactionData,
  GlacierPolicyApiDeclineTransactionErrors,
  GlacierPolicyApiDeclineTransactionResponses,
  GlacierPolicyApiDeleteCommercialPropertyCoverageData,
  GlacierPolicyApiDeleteCommercialPropertyCoverageResponses,
  GlacierPolicyApiDeleteDentistData,
  GlacierPolicyApiDeleteDentistResponses,
  GlacierPolicyApiDeleteLocationData,
  GlacierPolicyApiDeleteLocationResponses,
  GlacierPolicyApiDeleteOwnedEntityData,
  GlacierPolicyApiDeleteOwnedEntityResponses,
  GlacierPolicyApiDeletePolicyRenewalFlagData,
  GlacierPolicyApiDeletePolicyRenewalFlagResponses,
  GlacierPolicyApiDeletePrintQueueData,
  GlacierPolicyApiDeletePrintQueueResponses,
  GlacierPolicyApiDeleteUnderwriterNotesData,
  GlacierPolicyApiDeleteUnderwriterNotesResponses,
  GlacierPolicyApiDetachDocumentData,
  GlacierPolicyApiDetachDocumentResponses,
  GlacierPolicyApiDiscardTransactionData,
  GlacierPolicyApiDiscardTransactionErrors,
  GlacierPolicyApiDiscardTransactionResponses,
  GlacierPolicyApiDownloadAllTransactionsDocumentsData,
  GlacierPolicyApiDownloadAllTransactionsDocumentsResponses,
  GlacierPolicyApiDownloadDocumentData,
  GlacierPolicyApiDownloadDocumentResponses,
  GlacierPolicyApiDownloadErpWorksheetsData,
  GlacierPolicyApiDownloadErpWorksheetsResponses,
  GlacierPolicyApiDownloadLookerDashboardCsvData,
  GlacierPolicyApiDownloadLookerDashboardCsvResponses,
  GlacierPolicyApiDownloadLookerDashboardPdfData,
  GlacierPolicyApiDownloadLookerDashboardPdfResponses,
  GlacierPolicyApiDownloadRatingWorksheetsData,
  GlacierPolicyApiDownloadRatingWorksheetsResponses,
  GlacierPolicyApiFinalizeMidtermChangeData,
  GlacierPolicyApiFinalizeMidtermChangeResponses,
  GlacierPolicyApiGetAgentAuthorityData,
  GlacierPolicyApiGetAgentAuthorityResponses,
  GlacierPolicyApiGetChildPolicyData,
  GlacierPolicyApiGetChildPolicyResponses,
  GlacierPolicyApiGetCommercialPropertyCoverageData,
  GlacierPolicyApiGetCommercialPropertyCoverageResponses,
  GlacierPolicyApiGetCommercialPropertyLocationData,
  GlacierPolicyApiGetCommercialPropertyLocationResponses,
  GlacierPolicyApiGetCyberLiabilityData,
  GlacierPolicyApiGetCyberLiabilityResponses,
  GlacierPolicyApiGetDentistData,
  GlacierPolicyApiGetDentistInformationData,
  GlacierPolicyApiGetDentistInformationResponses,
  GlacierPolicyApiGetDentistPricingData,
  GlacierPolicyApiGetDentistPricingResponses,
  GlacierPolicyApiGetDentistProceduresData,
  GlacierPolicyApiGetDentistProceduresResponses,
  GlacierPolicyApiGetDentistResponses,
  GlacierPolicyApiGetFormulasData,
  GlacierPolicyApiGetFormulasResponses,
  GlacierPolicyApiGetLatestTransactionLatestAttemptData,
  GlacierPolicyApiGetLatestTransactionLatestAttemptResponses,
  GlacierPolicyApiGetLatestTransactionSummaryData,
  GlacierPolicyApiGetLatestTransactionSummaryResponses,
  GlacierPolicyApiGetLocationData,
  GlacierPolicyApiGetLocationResponses,
  GlacierPolicyApiGetObjectDetailsData,
  GlacierPolicyApiGetObjectDetailsResponses,
  GlacierPolicyApiGetOwnedEntityData,
  GlacierPolicyApiGetOwnedEntityResponses,
  GlacierPolicyApiGetPlCoverageData,
  GlacierPolicyApiGetPlCoverageResponses,
  GlacierPolicyApiGetPolicyAlertsData,
  GlacierPolicyApiGetPolicyAlertsResponses,
  GlacierPolicyApiGetPolicyData,
  GlacierPolicyApiGetPolicyDetailsData,
  GlacierPolicyApiGetPolicyDetailsResponses,
  GlacierPolicyApiGetPolicyPermissionsData,
  GlacierPolicyApiGetPolicyPermissionsResponses,
  GlacierPolicyApiGetPolicyResponses,
  GlacierPolicyApiGetPolicySummaryData,
  GlacierPolicyApiGetPolicySummaryResponses,
  GlacierPolicyApiGetPolicySummarySearchData,
  GlacierPolicyApiGetPolicySummarySearchResponses,
  GlacierPolicyApiGetPolicyTermsData,
  GlacierPolicyApiGetPolicyTermsResponses,
  GlacierPolicyApiGetPolicyWithSummariesData,
  GlacierPolicyApiGetPolicyWithSummariesResponses,
  GlacierPolicyApiGetPracticeOwnersData,
  GlacierPolicyApiGetPracticeOwnersResponses,
  GlacierPolicyApiGetPrintQueueData,
  GlacierPolicyApiGetPrintQueueResponses,
  GlacierPolicyApiGetSpecialFormsData,
  GlacierPolicyApiGetSpecialFormsResponses,
  GlacierPolicyApiGetSummaryOfChangesPdfData,
  GlacierPolicyApiGetSummaryOfChangesPdfResponses,
  GlacierPolicyApiGetTransactionDetailData,
  GlacierPolicyApiGetTransactionDetailResponses,
  GlacierPolicyApiGetTransactionSummaryData,
  GlacierPolicyApiGetTransactionSummaryResponses,
  GlacierPolicyApiIssuePolicyData,
  GlacierPolicyApiIssuePolicyResponses,
  GlacierPolicyApiListDocumentsData,
  GlacierPolicyApiListDocumentsResponses,
  GlacierPolicyApiListObjectSummariesData,
  GlacierPolicyApiListObjectSummariesResponses,
  GlacierPolicyApiListPoliciesData,
  GlacierPolicyApiListPoliciesResponses,
  GlacierPolicyApiListTransactionsData,
  GlacierPolicyApiListTransactionsResponses,
  GlacierPolicyApiListUnderwriterNotesData,
  GlacierPolicyApiListUnderwriterNotesResponses,
  GlacierPolicyApiPremiumRenewalNoticeData,
  GlacierPolicyApiPremiumRenewalNoticeResponses,
  GlacierPolicyApiPremiumStatementData,
  GlacierPolicyApiPremiumStatementResponses,
  GlacierPolicyApiPricePreviewMidtermChangeData,
  GlacierPolicyApiPricePreviewMidtermChangeResponses,
  GlacierPolicyApiPrintQueueData,
  GlacierPolicyApiPrintQueueResponses,
  GlacierPolicyApiRatePolicyData,
  GlacierPolicyApiRatePolicyErrors,
  GlacierPolicyApiRatePolicyResponses,
  GlacierPolicyApiReasonForChangePreviewData,
  GlacierPolicyApiReasonForChangePreviewResponses,
  GlacierPolicyApiReferPolicyData,
  GlacierPolicyApiReferPolicyErrors,
  GlacierPolicyApiReferPolicyResponses,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponses,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponses,
  GlacierPolicyApiRegenerateCompletePolicyBundleData,
  GlacierPolicyApiRegenerateCompletePolicyBundleResponses,
  GlacierPolicyApiRegenerateDocumentData,
  GlacierPolicyApiRegenerateDocumentResponses,
  GlacierPolicyApiRenewalSummaryOfChangesData,
  GlacierPolicyApiRenewalSummaryOfChangesResponses,
  GlacierPolicyApiReopenTransactionData,
  GlacierPolicyApiReopenTransactionErrors,
  GlacierPolicyApiReopenTransactionResponses,
  GlacierPolicyApiReopenUnlockedAccountData,
  GlacierPolicyApiReopenUnlockedAccountErrors,
  GlacierPolicyApiReopenUnlockedAccountResponses,
  GlacierPolicyApiRevertTransactionData,
  GlacierPolicyApiRevertTransactionResponses,
  GlacierPolicyApiSaveDentistTruthmdData,
  GlacierPolicyApiSaveDentistTruthmdResponses,
  GlacierPolicyApiSearchTruthmdDataData,
  GlacierPolicyApiSearchTruthmdDataResponses,
  GlacierPolicyApiSetDentistAsFirstNamedInsuredData,
  GlacierPolicyApiSetDentistAsFirstNamedInsuredResponses,
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData,
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponses,
  GlacierPolicyApiSetPolicyRenewalFlagData,
  GlacierPolicyApiSetPolicyRenewalFlagResponses,
  GlacierPolicyApiSetReasonForChangeData,
  GlacierPolicyApiSetReasonForChangeResponses,
  GlacierPolicyApiSpecimenPreviewData,
  GlacierPolicyApiSpecimenPreviewResponses,
  GlacierPolicyApiStartChangeExpirationDateMidtermData,
  GlacierPolicyApiStartChangeExpirationDateMidtermResponses,
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData,
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponses,
  GlacierPolicyApiUndoDeleteDentistData,
  GlacierPolicyApiUndoDeleteDentistResponses,
  GlacierPolicyApiUndoDeleteLocationData,
  GlacierPolicyApiUndoDeleteLocationResponses,
  GlacierPolicyApiUndoDeleteOwnedEntityData,
  GlacierPolicyApiUndoDeleteOwnedEntityResponses,
  GlacierPolicyApiUpdateBasicDentistData,
  GlacierPolicyApiUpdateBasicDentistResponses,
  GlacierPolicyApiUpdateBypassValidatorsData,
  GlacierPolicyApiUpdateBypassValidatorsResponses,
  GlacierPolicyApiUpdateCommercialPropertyCoverageData,
  GlacierPolicyApiUpdateCommercialPropertyCoverageResponses,
  GlacierPolicyApiUpdateCpCoverageData,
  GlacierPolicyApiUpdateCpCoverageResponses,
  GlacierPolicyApiUpdateCyberLiabilityData,
  GlacierPolicyApiUpdateCyberLiabilityResponses,
  GlacierPolicyApiUpdateDentistInformationData,
  GlacierPolicyApiUpdateDentistInformationResponses,
  GlacierPolicyApiUpdateDentistPricingData,
  GlacierPolicyApiUpdateDentistPricingResponses,
  GlacierPolicyApiUpdateDentistProceduresData,
  GlacierPolicyApiUpdateDentistProceduresResponses,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponses,
  GlacierPolicyApiUpdateDocumentData,
  GlacierPolicyApiUpdateDocumentResponses,
  GlacierPolicyApiUpdatedOwnedEntityData,
  GlacierPolicyApiUpdatedOwnedEntityResponses,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponses,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponses,
  GlacierPolicyApiUpdateGeneralLiabilityData,
  GlacierPolicyApiUpdateGeneralLiabilityResponses,
  GlacierPolicyApiUpdateLocationData,
  GlacierPolicyApiUpdateLocationResponses,
  GlacierPolicyApiUpdatePlCoverageData,
  GlacierPolicyApiUpdatePlCoverageResponses,
  GlacierPolicyApiUpdatePlPracticeOwnerData,
  GlacierPolicyApiUpdatePlPracticeOwnerResponses,
  GlacierPolicyApiUpdatePolicyDetailsData,
  GlacierPolicyApiUpdatePolicyDetailsResponses,
  GlacierPolicyApiUpdatePrimaryLocationData,
  GlacierPolicyApiUpdatePrimaryLocationResponses,
  GlacierPolicyApiUpdateUnderwriterNotesData,
  GlacierPolicyApiUpdateUnderwriterNotesResponses,
  GlacierPolicyApiUploadDocumentData,
  GlacierPolicyApiUploadDocumentResponses,
  GlacierPolicyApiUploadDocumentsWithMetadataData,
  GlacierPolicyApiUploadDocumentsWithMetadataResponses,
  GlacierPolicyCloneApiCopyPolicyEndpointData,
  GlacierPolicyCloneApiCopyPolicyEndpointResponses,
  GlacierPolicyConditionsApiCreateBindingConditionData,
  GlacierPolicyConditionsApiCreateBindingConditionResponses,
  GlacierPolicyConditionsApiCreateTermsConditionData,
  GlacierPolicyConditionsApiCreateTermsConditionResponses,
  GlacierPolicyConditionsApiDeleteBindingConditionData,
  GlacierPolicyConditionsApiDeleteBindingConditionResponses,
  GlacierPolicyConditionsApiDeleteTermsConditionData,
  GlacierPolicyConditionsApiDeleteTermsConditionResponses,
  GlacierPolicyConditionsApiListBindingConditionsData,
  GlacierPolicyConditionsApiListBindingConditionsResponses,
  GlacierPolicyConditionsApiListTermsConditionsData,
  GlacierPolicyConditionsApiListTermsConditionsResponses,
  GlacierPolicyConditionsApiUpdateBindingConditionData,
  GlacierPolicyConditionsApiUpdateBindingConditionResponses,
  GlacierPolicyConditionsApiUpdateTermsConditionData,
  GlacierPolicyConditionsApiUpdateTermsConditionResponses,
  GlacierPolicyErpApiGetErpEligibleDatesData,
  GlacierPolicyErpApiGetErpEligibleDatesResponses,
  GlacierPolicyErpApiGetErpSectionsData,
  GlacierPolicyErpApiGetErpSectionsResponses,
  GlacierPolicyErpApiSaveErpSelectionsData,
  GlacierPolicyErpApiSaveErpSelectionsResponses,
  GlacierPolicyErpApiStartErpEndorsementData,
  GlacierPolicyErpApiStartErpEndorsementResponses,
  GlacierPolicyFormsApiAttachFormToDentistData,
  GlacierPolicyFormsApiAttachFormToDentistResponses,
  GlacierPolicyFormsApiAttachFormToEntityData,
  GlacierPolicyFormsApiAttachFormToEntityResponses,
  GlacierPolicyFormsApiAttachFormToLocationData,
  GlacierPolicyFormsApiAttachFormToLocationResponses,
  GlacierPolicyFormsApiAttachFormToPolicyData,
  GlacierPolicyFormsApiAttachFormToPolicyResponses,
  GlacierPolicyFormsApiDetachFormFromDentistData,
  GlacierPolicyFormsApiDetachFormFromDentistResponses,
  GlacierPolicyFormsApiDetachFormFromEntityData,
  GlacierPolicyFormsApiDetachFormFromEntityResponses,
  GlacierPolicyFormsApiDetachFormFromLocationData,
  GlacierPolicyFormsApiDetachFormFromLocationResponses,
  GlacierPolicyFormsApiDetachFormFromPolicyData,
  GlacierPolicyFormsApiDetachFormFromPolicyResponses,
  GlacierPolicyFormsApiGetAvailableEndorsementsData,
  GlacierPolicyFormsApiGetAvailableEndorsementsResponses,
  GlacierPolicyFormsApiGetDentistAttachedFormsData,
  GlacierPolicyFormsApiGetDentistAttachedFormsResponses,
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponses,
  GlacierPolicyFormsApiGetEntityAttachedFormsData,
  GlacierPolicyFormsApiGetEntityAttachedFormsResponses,
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponses,
  GlacierPolicyFormsApiGetLocationAttachedFormsData,
  GlacierPolicyFormsApiGetLocationAttachedFormsResponses,
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponses,
  GlacierPolicyFormsApiGetQuestionsByDentistData,
  GlacierPolicyFormsApiGetQuestionsByDentistResponses,
  GlacierPolicyFormsApiGetQuestionsByEntityData,
  GlacierPolicyFormsApiGetQuestionsByEntityResponses,
  GlacierPolicyFormsApiGetQuestionsByLocationData,
  GlacierPolicyFormsApiGetQuestionsByLocationResponses,
  GlacierPolicyFormsApiGetQuestionsByPolicyData,
  GlacierPolicyFormsApiGetQuestionsByPolicyResponses,
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponses,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponses,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponses,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponses,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponses,
  GlacierPolicyFormsApiRenderFormData,
  GlacierPolicyFormsApiRenderFormResponses,
  GlacierReportsApiDownloadReportData,
  GlacierReportsApiDownloadReportResponses,
  GlacierReportsApiListReportsData,
  GlacierReportsApiListReportsResponses,
  GlacierReportsApiPreviewReportData,
  GlacierReportsApiPreviewReportResponses,
  GlacierUsersApiCurrentUserData,
  GlacierUsersApiCurrentUserResponses,
  GlacierUsersApiForgotPasswordEndpointData,
  GlacierUsersApiForgotPasswordEndpointResponses,
  GlacierUsersApiListUsersData,
  GlacierUsersApiListUsersResponses,
  GlacierUsersApiRelatedUsersData,
  GlacierUsersApiRelatedUsersResponses,
  GlacierUsersApiResetPasswordEndpointData,
  GlacierUsersApiResetPasswordEndpointResponses,
  GlacierUsersApiUnderwritersData,
  GlacierUsersApiUnderwritersResponses,
  GlacierUsersFeatureFlagsApiGetFeatureFlagsData,
  GlacierUsersFeatureFlagsApiGetFeatureFlagsResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List Users
 */
export const glacierUsersApiListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<GlacierUsersApiListUsersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierUsersApiListUsersResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/users/',
    ...options,
  });

/**
 * Current User
 */
export const glacierUsersApiCurrentUser = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierUsersApiCurrentUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierUsersApiCurrentUserResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/users/current_user',
    ...options,
  });

/**
 * Related Users
 */
export const glacierUsersApiRelatedUsers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierUsersApiRelatedUsersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierUsersApiRelatedUsersResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/users/related_users',
    ...options,
  });

/**
 * Underwriters
 */
export const glacierUsersApiUnderwriters = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierUsersApiUnderwritersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierUsersApiUnderwritersResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/users/underwriters',
    ...options,
  });

/**
 * Forgot Password Endpoint
 */
export const glacierUsersApiForgotPasswordEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierUsersApiForgotPasswordEndpointData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierUsersApiForgotPasswordEndpointResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/v1/users/forgot-password/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset Password Endpoint
 */
export const glacierUsersApiResetPasswordEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierUsersApiResetPasswordEndpointData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierUsersApiResetPasswordEndpointResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/v1/users/reset-password/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Feature Flags
 *
 * Return all switches marked `deliverable_to_ui` with their current active state.
 *
 * Unauthenticated callers receive the same response as authenticated ones —
 * the deliverable_to_ui flag controls visibility, not auth state.
 */
export const glacierUsersFeatureFlagsApiGetFeatureFlags = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GlacierUsersFeatureFlagsApiGetFeatureFlagsData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    GlacierUsersFeatureFlagsApiGetFeatureFlagsResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/feature-flags/', ...options });

/**
 * List Policies
 *
 * List policies the requesting user may access.
 *
 * Staff are unrestricted (including DISCARDED), exactly as before this gate. Non-staff
 * are scoped to the policies their agency may access via
 * ``PolicyLookupTable.user_permission_qs`` -- the same tenancy primitive
 * ``get_policy_summary`` uses -- so an agent only ever sees their own agencies' policies
 * rather than the entire event store (DC-3454).
 */
export const glacierPolicyApiListPolicies = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierPolicyApiListPoliciesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierPolicyApiListPoliciesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/',
    ...options,
  });

/**
 * Create Policy
 */
export const glacierPolicyApiCreatePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreatePolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreatePolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Policy Summary
 */
export const glacierPolicyApiGetPolicySummary = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierPolicyApiGetPolicySummaryData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierPolicyApiGetPolicySummaryResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/summaries/',
    ...options,
  });

/**
 * Get Policy Summary Search
 *
 * Evergreen Dashboard "Insureds only" search.
 *
 * Restricted to First Named Insured and insured dentist names, tokenized
 * and order-independent, spanning every transaction status the user can
 * otherwise see -- see ``PolicyLookupTable.insured_search``.
 */
export const glacierPolicyApiGetPolicySummarySearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicySummarySearchData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicySummarySearchResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/summaries/search/',
    ...options,
  });

/**
 * Delete Print Queue
 *
 * Deletes a print queue item specified by `print_queue_id`.
 *
 * This function performs a soft delete operation on the print queue
 * by setting its 'deleted_at' attribute to the current timestamp.
 */
export const glacierPolicyApiDeletePrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeletePrintQueueData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeletePrintQueueResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/print_queue/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Print Queue
 *
 * Returns the list of policies that are visible to the print queue
 */
export const glacierPolicyApiGetPrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierPolicyApiGetPrintQueueData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierPolicyApiGetPrintQueueResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/print_queue/',
    ...options,
  });

/**
 * Print Queue
 *
 * Starts a print queue for the given accounts, and return the zip file
 */
export const glacierPolicyApiPrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPrintQueueData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiPrintQueueResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/print_queue/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Policy
 */
export const glacierPolicyApiGetPolicy = <ThrowOnError extends boolean = false>(
  options: Options<GlacierPolicyApiGetPolicyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/',
    ...options,
  });

/**
 * Get Policy Alerts
 */
export const glacierPolicyApiGetPolicyAlerts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyAlertsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyAlertsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/alerts/',
    ...options,
  });

/**
 * Acknowledge Policy Alert
 */
export const glacierPolicyApiAcknowledgePolicyAlert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAcknowledgePolicyAlertData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAcknowledgePolicyAlertResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/alerts/{alert_id}/acknowledge/',
    ...options,
  });

/**
 * Get Latest Transaction Summary
 */
export const glacierPolicyApiGetLatestTransactionSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetLatestTransactionSummaryData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetLatestTransactionSummaryResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/latest_transaction/summary',
    ...options,
  });

/**
 * Get Latest Transaction Latest Attempt
 */
export const glacierPolicyApiGetLatestTransactionLatestAttempt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetLatestTransactionLatestAttemptData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetLatestTransactionLatestAttemptResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/latest_transaction/latest_attempt',
    ...options,
  });

/**
 * Assign Agent
 */
export const glacierPolicyApiAssignAgent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignAgentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAssignAgentResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/assign_agent/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assign Underwriter
 */
export const glacierPolicyApiAssignUnderwriter = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignUnderwriterData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAssignUnderwriterResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/assign_underwriter/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assign
 */
export const glacierPolicyApiAssign = <ThrowOnError extends boolean = false>(
  options: Options<GlacierPolicyApiAssignData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAssignResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assignable
 */
export const glacierPolicyApiAssignable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignableData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiAssignableResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/assignable/',
    ...options,
  });

/**
 * Get Policy With Summaries
 */
export const glacierPolicyApiGetPolicyWithSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyWithSummariesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/summaries/',
    ...options,
  });

/**
 * Get Policy Permissions
 */
export const glacierPolicyApiGetPolicyPermissions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyPermissionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyPermissionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/permissions/',
    ...options,
  });

/**
 * Decline Transaction
 *
 * This acts as DECLINE or NOT TAKEN if user is an Underwriter or Agent respectively
 */
export const glacierPolicyApiDeclineTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeclineTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDeclineTransactionResponses,
    GlacierPolicyApiDeclineTransactionErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/decline/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Discard Transaction
 *
 * Discards a transaction. A discarded transaction cannot be reopened
 */
export const glacierPolicyApiDiscardTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDiscardTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDiscardTransactionResponses,
    GlacierPolicyApiDiscardTransactionErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/discard/',
    ...options,
  });

/**
 * Reopen Transaction
 *
 * Reopens a transaction. Only transactions that are in DECLINED or NOT_TAKEN can be reopened
 */
export const glacierPolicyApiReopenTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReopenTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiReopenTransactionResponses,
    GlacierPolicyApiReopenTransactionErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/reopen/',
    ...options,
  });

/**
 * Add Location
 */
export const glacierPolicyApiAddLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAddLocationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAddLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Primary Location
 */
export const glacierPolicyApiUpdatePrimaryLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePrimaryLocationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUpdatePrimaryLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/primary/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Location
 */
export const glacierPolicyApiDeleteLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteLocationData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeleteLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
    ...options,
  });

/**
 * Get Location
 */
export const glacierPolicyApiGetLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetLocationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
    ...options,
  });

/**
 * Update Location
 */
export const glacierPolicyApiUpdateLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateLocationData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GlacierPolicyApiUpdateLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Update Locations
 */
export const glacierPolicyApiBulkUpdateLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiBulkUpdateLocationsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GlacierPolicyApiBulkUpdateLocationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/locations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Undo Delete Location
 */
export const glacierPolicyApiUndoDeleteLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteLocationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUndoDeleteLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/location/{location_id}/reinstate',
    ...options,
  });

/**
 * Get Dentist
 */
export const glacierPolicyApiGetDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}',
    ...options,
  });

/**
 * Set Dentist As First Named Insured
 *
 * Set a dentist as the first named insured for the policy.
 * Expects a dentist ID in the request body.
 */
export const glacierPolicyApiSetDentistAsFirstNamedInsured = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiSetDentistAsFirstNamedInsuredData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSetDentistAsFirstNamedInsuredResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/set-dentist-as-first-named-insured/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Owned Entity As First Named Insured
 *
 * Set an owned entity as the first named insured for the policy.
 * Expects an owned entity ID in the request body.
 */
export const glacierPolicyApiSetOwnedEntityAsFirstNamedInsured = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned-entity/set-owned-entity-as-first-named-insured/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add Dentist
 */
export const glacierPolicyApiAddDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAddDentistData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAddDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Dentist
 */
export const glacierPolicyApiDeleteDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteDentistData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeleteDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/',
    ...options,
  });

/**
 * Update Basic Dentist
 */
export const glacierPolicyApiUpdateBasicDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateBasicDentistData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateBasicDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Undo Delete Dentist
 */
export const glacierPolicyApiUndoDeleteDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteDentistData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUndoDeleteDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/reinstate/',
    ...options,
  });

/**
 * Get Dentist Information
 */
export const glacierPolicyApiGetDentistInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistInformationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetDentistInformationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/',
    ...options,
  });

/**
 * Update Dentist Information
 */
export const glacierPolicyApiUpdateDentistInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistInformationData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateDentistInformationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Dentist Pricing
 */
export const glacierPolicyApiGetDentistPricing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistPricingData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetDentistPricingResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/',
    ...options,
  });

/**
 * Update Dentist Pricing
 */
export const glacierPolicyApiUpdateDentistPricing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistPricingData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateDentistPricingResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Dentist Procedures
 */
export const glacierPolicyApiGetDentistProcedures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistProceduresData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetDentistProceduresResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/',
    ...options,
  });

/**
 * Update Dentist Procedures
 */
export const glacierPolicyApiUpdateDentistProcedures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistProceduresData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateDentistProceduresResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Truthmd Data
 *
 * Search TruthMD platform for dentist data.
 * Requires either NPI or licenseNumber + licenseState combination.
 */
export const glacierPolicyApiSearchTruthmdData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSearchTruthmdDataData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSearchTruthmdDataResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd-search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Clear Dentist Truthmd
 *
 * Clear TruthMD data for a dentist.
 * This removes all TruthMD data associated with the dentist.
 */
export const glacierPolicyApiClearDentistTruthmd = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiClearDentistTruthmdData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiClearDentistTruthmdResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd/',
    ...options,
  });

/**
 * Save Dentist Truthmd
 *
 * Save TruthMD data for a dentist.
 * Call this endpoint after searching to persist the TruthMD data.
 */
export const glacierPolicyApiSaveDentistTruthmd = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSaveDentistTruthmdData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSaveDentistTruthmdResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/truthmd/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Practice Owners
 */
export const glacierPolicyApiGetPracticeOwners = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPracticeOwnersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPracticeOwnersResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/pl/practice_owners/',
    ...options,
  });

/**
 * Update Pl Practice Owner
 */
export const glacierPolicyApiUpdatePlPracticeOwner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePlPracticeOwnerData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdatePlPracticeOwnerResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/pl/practice_owners/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Pl Coverage
 */
export const glacierPolicyApiGetPlCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPlCoverageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPlCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/pl/coverage/',
    ...options,
  });

/**
 * Update Pl Coverage
 */
export const glacierPolicyApiUpdatePlCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePlCoverageData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdatePlCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/pl/coverage/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Policy Details
 */
export const glacierPolicyApiGetPolicyDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/details/',
    ...options,
  });

/**
 * Update Policy Details
 */
export const glacierPolicyApiUpdatePolicyDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePolicyDetailsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdatePolicyDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/details/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Bypass Validators
 */
export const glacierPolicyApiUpdateBypassValidators = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateBypassValidatorsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateBypassValidatorsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/bypass-validators/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refresh Commercial Property With Verisk
 */
export const glacierPolicyApiRefreshCommercialPropertyWithVerisk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/verisk',
    ...options,
  });

/**
 * Refresh Commercial Property With Corelogic
 */
export const glacierPolicyApiRefreshCommercialPropertyWithCorelogic = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/corelogic',
    ...options,
  });

/**
 * Add Commercial Property Coverage
 */
export const glacierPolicyApiAddCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiAddCommercialPropertyCoverageData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAddCommercialPropertyCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Commercial Property Coverage
 */
export const glacierPolicyApiDeleteCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiDeleteCommercialPropertyCoverageData,
    ThrowOnError
  >
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeleteCommercialPropertyCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
    ...options,
  });

/**
 * Get Commercial Property Location
 */
export const glacierPolicyApiGetCommercialPropertyLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetCommercialPropertyLocationData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetCommercialPropertyLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
    ...options,
  });

/**
 * Update Commercial Property Coverage
 */
export const glacierPolicyApiUpdateCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateCommercialPropertyCoverageData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateCommercialPropertyCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Undo Delete Commercial Property Coverage
 */
export const glacierPolicyApiUndoDeleteCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/reinstate/',
    ...options,
  });

/**
 * Get Commercial Property Coverage
 */
export const glacierPolicyApiGetCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetCommercialPropertyCoverageData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetCommercialPropertyCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/coverage/',
    ...options,
  });

/**
 * Update Cp Coverage
 */
export const glacierPolicyApiUpdateCpCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateCpCoverageData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateCpCoverageResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cp/coverage/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rate Policy
 */
export const glacierPolicyApiRatePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRatePolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRatePolicyResponses,
    GlacierPolicyApiRatePolicyErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/rate/',
    ...options,
  });

/**
 * Get Formulas
 */
export const glacierPolicyApiGetFormulas = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetFormulasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetFormulasResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/formulas/',
    ...options,
  });

/**
 * Create Owned Entities
 */
export const glacierPolicyApiCreateOwnedEntities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateOwnedEntitiesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreateOwnedEntitiesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned_entities/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Owned Entity
 */
export const glacierPolicyApiDeleteOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteOwnedEntityData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeleteOwnedEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
    ...options,
  });

/**
 * Get Owned Entity
 */
export const glacierPolicyApiGetOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetOwnedEntityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetOwnedEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
    ...options,
  });

/**
 * Updated Owned Entity
 */
export const glacierPolicyApiUpdatedOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatedOwnedEntityData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdatedOwnedEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Undo Delete Owned Entity
 */
export const glacierPolicyApiUndoDeleteOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteOwnedEntityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUndoDeleteOwnedEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/reinstate/',
    ...options,
  });

/**
 * Update General Liability
 */
export const glacierPolicyApiUpdateGeneralLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateGeneralLiabilityData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateGeneralLiabilityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/general_liability/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Employment Practices Liability
 */
export const glacierPolicyApiUpdateEmploymentPracticesLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/employment_practices_liability/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Erisa And Employee Benefits
 */
export const glacierPolicyApiUpdateErisaAndEmployeeBenefits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/erisa_and_employee_benefits/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Cyber Liability
 */
export const glacierPolicyApiGetCyberLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetCyberLiabilityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetCyberLiabilityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cyber_liability/',
    ...options,
  });

/**
 * Update Cyber Liability
 */
export const glacierPolicyApiUpdateCyberLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateCyberLiabilityData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateCyberLiabilityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cyber_liability/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Issue Policy
 */
export const glacierPolicyApiIssuePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiIssuePolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiIssuePolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/transactions/issue-policy/',
    ...options,
  });

/**
 * Get Agent Authority
 *
 * Get the agent authority for the policy.
 */
export const glacierPolicyApiGetAgentAuthority = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetAgentAuthorityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetAgentAuthorityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/agent-authority/',
    ...options,
  });

/**
 * Create Midterm Transaction
 */
export const glacierPolicyApiCreateMidtermTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateMidtermTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreateMidtermTransactionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Change Expiration Date Midterm
 *
 * Start a "Change Expiration Date" midterm endorsement.
 *
 * Rejects the request if a *bound* child renewal exists. Discards any
 * *in-progress* child renewal before creating the new endorsement, so the
 * renewal will be regenerated against the new expiration date.
 *
 * DC-3260: the entire body runs inside ``transaction.atomic()`` so a
 * later failure (ValueError from start_expiration_date_change, rating
 * error, auto_attach_forms or persist_events failure) rolls back the
 * earlier close_renewal_policy. Otherwise the in-progress child renewal
 * would be permanently closed even when the endorsement attempt failed.
 */
export const glacierPolicyApiStartChangeExpirationDateMidterm = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiStartChangeExpirationDateMidtermData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiStartChangeExpirationDateMidtermResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/change-expiration-date/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Change Endorsement Effective Date
 *
 * Change the effective date of an in-progress endorsement transaction.
 *
 * Re-anchors all entities added or soft-deleted during the transaction to the
 * new date. Only allowed for POLICY_ENDORSEMENT transactions while IN_PROGRESS.
 */
export const glacierPolicyApiChangeEndorsementEffectiveDate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiChangeEndorsementEffectiveDateData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiChangeEndorsementEffectiveDateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/effective-date/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Reason For Change
 *
 * Persist the endorsement "reason for change" from the pricing-preview autosave.
 *
 * Driven by mountaineer's PricingPreview autosave (and manual save) on the policy
 * pricing-preview screen. "Reason for change" only applies to an in-progress endorsement,
 * so when the current transaction is not an in-progress ``POLICY_ENDORSEMENT`` (e.g. a
 * debounced autosave that lands after the endorsement was finalized/bound/cancelled, or a
 * non-endorsement transaction) this returns a benign ``200 {"success": True, "skipped":
 * True}`` no-op instead of a 500 — nothing is persisted, and ``skipped`` flags that. See
 * DP1-3796 / Sentry ASPEN-DENTAL-1DS. Genuine failures on the persist path still return a
 * 500 so they stay visible to error monitoring.
 *
 * NOTE: frontend consumers should honor ``skipped`` (avoid the success toast / optimistic
 * cache write) so an unpersisted value is not shown as saved — tracked as a mountaineer
 * follow-up.
 */
export const glacierPolicyApiSetReasonForChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSetReasonForChangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSetReasonForChangeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/set-reason-for-change/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Price Preview Midterm Change
 */
export const glacierPolicyApiPricePreviewMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiPricePreviewMidtermChangeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/price-preview/',
    ...options,
  });

/**
 * Reason For Change Preview
 *
 * Generate auto-populated "Reason for Change" verbiage from the midterm diff.
 *
 * DC-3224. Computes the diff between the previous and current (in-progress)
 * transaction by reusing the same engine that powers the Summary of Changes (no side
 * effects, read-only), then maps each relevant change to its Aspen-spec phrase.
 * Changes with no spec phrase contribute nothing (the list can come back empty).
 *
 * Read-only, so it uses ``FastPolicy`` + the policy-view etag cache like the sibling
 * price-preview on the same screen (the verbiage is a pure function of the policy
 * events, so the sequence-number etag invalidates exactly when it should).
 */
export const glacierPolicyApiReasonForChangePreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReasonForChangePreviewData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiReasonForChangePreviewResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/reason-for-change-preview/',
    ...options,
  });

/**
 * Finalize Midterm Change
 *
 * Validate permissions and required fields, run the finalize commands, and
 * persist the transaction. Domain (`ValueError`) and unexpected failures are
 * both converted to a 400 rather than an opaque 500.
 */
export const glacierPolicyApiFinalizeMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiFinalizeMidtermChangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiFinalizeMidtermChangeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/finalize/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Cancel Midterm Change
 */
export const glacierPolicyApiCancelMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCancelMidtermChangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCancelMidtermChangeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/cancel/',
    ...options,
  });

/**
 * Get Summary Of Changes Pdf
 *
 * Generate and return the Summary of Changes PDF for a policy without saving it.
 *
 * This endpoint generates the Summary of Changes document by comparing the current
 * transaction with the previous transaction, but does not create any events or
 * persist the file to the database.
 */
export const glacierPolicyApiGetSummaryOfChangesPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetSummaryOfChangesPdfData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetSummaryOfChangesPdfResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/summary-of-changes/pdf/',
    ...options,
  });

/**
 * Revert Transaction
 */
export const glacierPolicyApiRevertTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRevertTransactionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRevertTransactionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/transactions/{number}/revert/',
    ...options,
  });

/**
 * Update Dentist Underwriting Questions
 */
export const glacierPolicyApiUpdateDentistUnderwritingQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/underwriting_questions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Premium Statement
 */
export const glacierPolicyApiPremiumStatement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPremiumStatementData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiPremiumStatementResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/premium-statement/',
    ...options,
  });

/**
 * Agency Bill Invoice
 */
export const glacierPolicyApiAgencyBillInvoice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAgencyBillInvoiceData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiAgencyBillInvoiceResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/agency-bill-invoice/',
    ...options,
  });

/**
 * Get Special Forms
 */
export const glacierPolicyApiGetSpecialForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetSpecialFormsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiGetSpecialFormsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/special-forms/',
    ...options,
  });

/**
 * Conditional Renewal Notice
 */
export const glacierPolicyApiConditionalRenewalNotice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiConditionalRenewalNoticeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiConditionalRenewalNoticeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/renewal-notice/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Rating Worksheets
 */
export const glacierPolicyApiDownloadRatingWorksheets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadRatingWorksheetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDownloadRatingWorksheetsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/rating_worksheets/{worksheet_enum}/',
    ...options,
  });

/**
 * Download Erp Worksheets
 *
 * Generate and download ERP worksheets.
 *
 * This endpoint generates ERP worksheets using ODT templates stored in S3.
 * Currently supports ERP Estimate worksheets for midterm endorsements and cancellations.
 */
export const glacierPolicyApiDownloadErpWorksheets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadErpWorksheetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDownloadErpWorksheetsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/erp_worksheets/{worksheet_enum}/',
    ...options,
  });

/**
 * Premium Renewal Notice
 */
export const glacierPolicyApiPremiumRenewalNotice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPremiumRenewalNoticeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiPremiumRenewalNoticeResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/premium-renewal-notice/',
    ...options,
  });

/**
 * Download Looker Dashboard Pdf
 *
 * Loss runs as a rendered PDF of the Looker dashboard.
 *
 * `data.loss_run_type` picks the slice of the claims report: liability
 * (Counterpart-handled claims) or property (Carrier-handled).
 */
export const glacierPolicyApiDownloadLookerDashboardPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadLookerDashboardPdfData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDownloadLookerDashboardPdfResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/looker_dashboard_pdf/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Looker Dashboard Csv
 *
 * Loss runs as a ZIP of one CSV per dashboard tile.
 *
 * `data.loss_run_type` picks the slice of the claims report: liability
 * (Counterpart-handled claims) or property (Carrier-handled).
 */
export const glacierPolicyApiDownloadLookerDashboardCsv = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadLookerDashboardCsvData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiDownloadLookerDashboardCsvResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/looker_dashboard_csv/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Specimen Preview
 */
export const glacierPolicyApiSpecimenPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSpecimenPreviewData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiSpecimenPreviewResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/generate-preview/specimen/',
    ...options,
  });

/**
 * List Documents
 */
export const glacierPolicyApiListDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiListDocumentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/',
    ...options,
  });

/**
 * Upload Document
 */
export const glacierPolicyApiUploadDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUploadDocumentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUploadDocumentResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Download All Transactions Documents
 *
 * Compile every committed transaction's policy documents into a single ordered PDF --
 * see ``glacier.policy.all_transactions_bundle``.
 */
export const glacierPolicyApiDownloadAllTransactionsDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiDownloadAllTransactionsDocumentsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyApiDownloadAllTransactionsDocumentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/all-transactions-documents/download/',
    ...options,
  });

/**
 * Upload Documents With Metadata
 *
 * Upload one or more documents with optional per-file metadata.
 *
 * Files are sent as multipart `files` fields.
 * Metadata is a JSON array of objects, one per file (matched by index):
 * [{"filename": "...", "description": "...", "category": "...", "subcategory": "..."}, ...]
 * All metadata fields are optional. If metadata array is shorter than files, remaining files
 * get defaults. Maximum 30 files per request.
 */
export const glacierPolicyApiUploadDocumentsWithMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUploadDocumentsWithMetadataData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiUploadDocumentsWithMetadataResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/upload/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Detach Document
 */
export const glacierPolicyApiDetachDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDetachDocumentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDetachDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/{document_id}/',
    ...options,
  });

/**
 * Update Document
 *
 * Update an uploaded document's metadata (filename, description, category, subcategory).
 *
 * Re-categorizing a document *into* a system-owned category (see
 * `AttachedDocumentType.system_owned_types`) is rejected with 422: those
 * categories are reserved for platform-generated documents. Re-saving a document
 * that is already in a system-owned category is allowed, so existing documents
 * (e.g. a user-uploaded cancellation notice, or a legacy misfiled ERP offer
 * letter) stay editable (DC-3715).
 */
export const glacierPolicyApiUpdateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDocumentData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/documents/{document_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Document Is Ready
 *
 * Check if a document is already rendered
 * Returns status 200 with status 200 if the document is ready, 404 with status 404 if it is not.
 */
export const documentIsReady = <ThrowOnError extends boolean = false>(
  options: Options<DocumentIsReadyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DocumentIsReadyResponses,
    DocumentIsReadyErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/document-warehouse/{document_id}/is-ready/',
    ...options,
  });

/**
 * Download Document
 */
export const glacierPolicyApiDownloadDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiDownloadDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/download/',
    ...options,
  });

/**
 * Regenerate Document
 */
export const glacierPolicyApiRegenerateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRegenerateDocumentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRegenerateDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/regenerate/',
    ...options,
  });

/**
 * Regenerate Complete Policy Bundle
 *
 * Regenerate complete policy bundle for midterm transactions.
 *
 * This endpoint allows Underwriting Admins to regenerate a complete policy bundle
 * with ALL forms from all transactions.
 *
 * Requirements:
 * - User must be Underwriting Admin
 * - Document must be a POLICY_BUNDLE
 * - Transaction must be ACTIVE (committed)
 * - Transaction type must be ENDORSEMENT or REINSTATED
 *
 * Args:
 * document_id: UUID of the document to regenerate
 * policy_id: UUID of the policy
 *
 * Returns:
 * 204 on success
 *
 * Raises:
 * HttpError 403: User not authorized
 * HttpError 400: Validation error (wrong document type, transaction status, or type)
 * HttpError 404: Document not found
 * HttpError 500: Internal server error
 */
export const glacierPolicyApiRegenerateCompletePolicyBundle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiRegenerateCompletePolicyBundleData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiRegenerateCompletePolicyBundleResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/regenerate-complete/',
    ...options,
  });

/**
 * Commit Transaction Test
 */
export const glacierPolicyApiCommitTransactionTest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCommitTransactionTestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCommitTransactionTestResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/commit_transaction_test/',
    ...options,
  });

/**
 * List Underwriter Notes
 */
export const glacierPolicyApiListUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListUnderwriterNotesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiListUnderwriterNotesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/underwriter-notes/',
    ...options,
  });

/**
 * Create Underwriter Notes
 */
export const glacierPolicyApiCreateUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateUnderwriterNotesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreateUnderwriterNotesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/underwriter-notes/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Underwriter Notes
 */
export const glacierPolicyApiDeleteUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteUnderwriterNotesData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeleteUnderwriterNotesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/',
    ...options,
  });

/**
 * Update Underwriter Notes
 */
export const glacierPolicyApiUpdateUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateUnderwriterNotesData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    GlacierPolicyApiUpdateUnderwriterNotesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reopen Unlocked Account
 *
 * Endpoint to reopen an unlocked account for system admin users.
 * Sets quote_type back to None and erases the policy_number.
 */
export const glacierPolicyApiReopenUnlockedAccount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReopenUnlockedAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiReopenUnlockedAccountResponses,
    GlacierPolicyApiReopenUnlockedAccountErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/reopen_unlocked_account/',
    ...options,
  });

/**
 * Create Policy Pending Cancellation Transaction
 */
export const glacierPolicyApiCreatePolicyPendingCancellationTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/midterm-change/pending-cancellation-policy/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List Object Summaries
 */
export const glacierPolicyApiListObjectSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListObjectSummariesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiListObjectSummariesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/object-summaries/{object_type}/',
    ...options,
  });

/**
 * Get Object Details
 *
 * One practice location, dentist, owned entity or CP location of a policy.
 *
 * A CP location carries ``parentVdl``: on an unbound renewal, the parent's
 * revenue, days open per week and valued daily limit days for the same
 * location as of the renewal's pin; null otherwise, or when the parent has
 * no such location.
 */
export const glacierPolicyApiGetObjectDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetObjectDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetObjectDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/object-details/{object_type}/{object_id}/',
    ...options,
  });

/**
 * Refer Policy
 *
 * Refer a policy to the agency's designated referral underwriter.
 *
 * Optionally attaches an agent note (stored as an UnderwriterNote with
 * source=REFERRAL) that the underwriter can review.
 */
export const glacierPolicyApiReferPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReferPolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiReferPolicyResponses,
    GlacierPolicyApiReferPolicyErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/refer/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Transactions
 *
 * Get all transaction snapshots for a policy for Time Travel functionality.
 * Each snapshot represents the final state of a transaction that users can navigate to.
 * Returns snapshots ordered by transaction number (newest first).
 */
export const glacierPolicyApiListTransactions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListTransactionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiListTransactionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/transactions/',
    ...options,
  });

/**
 * Get Transaction Summary
 *
 * Get the summary of changes for a specific transaction.
 *
 * Returns the diff between the previous and current transaction,
 * showing what changed when the transaction was committed.
 *
 * Supports both same-policy comparisons (typical midterm changes)
 * and cross-policy comparisons (renewals, rollovers).
 */
export const glacierPolicyApiGetTransactionSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetTransactionSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetTransactionSummaryResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/transactions/{transaction_number}/summary/',
    ...options,
  });

/**
 * Get Transaction Detail
 *
 * Get transaction detail for Time Travel functionality.
 * Returns transaction details and assigned user information.
 * This allows users to view the transaction details for a specific transaction number.
 * Unlike other endpoints, this one always uses the transaction_number from the URL parameter,
 * not from request headers.
 */
export const glacierPolicyApiGetTransactionDetail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetTransactionDetailData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetTransactionDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/transaction-detail/{transaction_number}/',
    ...options,
  });

/**
 * Confirm Rating Checks
 */
export const glacierPolicyApiConfirmRatingChecks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiConfirmRatingChecksData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiConfirmRatingChecksResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/confirm-rating-checks/',
    ...options,
  });

/**
 * Delete Policy Renewal Flag
 */
export const glacierPolicyApiDeletePolicyRenewalFlag = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeletePolicyRenewalFlagData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GlacierPolicyApiDeletePolicyRenewalFlagResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/renewal-flag/{flag}',
    ...options,
  });

/**
 * Set Policy Renewal Flag
 */
export const glacierPolicyApiSetPolicyRenewalFlag = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSetPolicyRenewalFlagData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiSetPolicyRenewalFlagResponses,
    unknown,
    ThrowOnError
  >({
    ...urlSearchParamsBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/renewal-flag/{flag}',
    ...options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...options.headers,
    },
  });

/**
 * Get Child Policy
 */
export const glacierPolicyApiGetChildPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetChildPolicyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetChildPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/child-policy/',
    ...options,
  });

/**
 * Get Policy Terms
 *
 * Return every term in the renewal chain ``account_id`` belongs to (DC-3253).
 *
 * Terms in a chain share a ``policyholder_id`` (the root term's account_id),
 * so the whole chain resolves in a single query -- no client-side chain
 * walking. Ordered most-recent-first for the dropdown; ``term_number`` is the
 * chronological ordinal (Term 1 = oldest). Non-staff are scoped to their own
 * agencies' terms via ``user_permission_qs`` (DC-3454).
 */
export const glacierPolicyApiGetPolicyTerms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyTermsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiGetPolicyTermsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/terms/',
    ...options,
  });

/**
 * Create Renewal
 *
 * Creates the renewal policy from this policy
 */
export const glacierPolicyApiCreateRenewal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateRenewalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCreateRenewalResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/create_renewal/',
    ...options,
  });

/**
 * Close Renewal
 *
 * Closes (discards) a renewal policy.
 * Must be called on the renewal policy itself, not the parent.
 */
export const glacierPolicyApiCloseRenewal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCloseRenewalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyApiCloseRenewalResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/close_renewal/',
    ...options,
  });

/**
 * Renewal Summary Of Changes
 *
 * Generate and return the Summary of Changes PDF for a renewal policy without saving it.
 *
 * This endpoint generates the Summary of Changes document by comparing the renewal
 * policy with its parent policy, but does not create any events or persist the file
 * to the database. Must be called on the renewal policy itself, not the parent.
 */
export const glacierPolicyApiRenewalSummaryOfChanges = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRenewalSummaryOfChangesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyApiRenewalSummaryOfChangesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/renewal_summary_of_changes/',
    ...options,
  });

/**
 * Policy Level Attached Endorsements
 *
 * Return all the attached endorsements at the policy level.
 *
 * When ``include_superseded`` is False (default) superseded forms are dropped
 * via ``deduplicate_attached_forms``; when True the deduped set is expanded to
 * also include actual supersession targets (see ``_listed_forms``) so
 * superseded entries are visible -- legacy same-``form_id`` duplicates with no
 * supersession link stay hidden either way. ``is_superseded`` /
 * ``superseded_by_transaction_number`` are computed over each entity's RAW
 * forms in both modes (the factory always receives ``*.attached_forms``).
 */
export const glacierPolicyFormsApiPolicyLevelAttachedEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/',
    ...options,
  });

/**
 * Attach Form To Policy
 */
export const glacierPolicyFormsApiAttachFormToPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToPolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Detach Form From Policy
 */
export const glacierPolicyFormsApiDetachFormFromPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromPolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/detach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Available Endorsements
 */
export const glacierPolicyFormsApiGetAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetAvailableEndorsementsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetAvailableEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/available-endorsements/',
    ...options,
  });

/**
 * Attach Form To Dentist
 */
export const glacierPolicyFormsApiAttachFormToDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToDentistData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Detach Form From Dentist
 */
export const glacierPolicyFormsApiDetachFormFromDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromDentistData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/detach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Dentist Attached Forms
 */
export const glacierPolicyFormsApiGetDentistAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetDentistAttachedFormsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetDentistAttachedFormsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/',
    ...options,
  });

/**
 * Get Dentist Available Endorsements
 */
export const glacierPolicyFormsApiGetDentistAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/available-endorsements/',
    ...options,
  });

/**
 * Attach Form To Location
 */
export const glacierPolicyFormsApiAttachFormToLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToLocationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Detach Form From Location
 */
export const glacierPolicyFormsApiDetachFormFromLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiDetachFormFromLocationData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/detach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Location Attached Forms
 */
export const glacierPolicyFormsApiGetLocationAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetLocationAttachedFormsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetLocationAttachedFormsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/',
    ...options,
  });

/**
 * Get Location Available Endorsements
 */
export const glacierPolicyFormsApiGetLocationAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/available-endorsements/',
    ...options,
  });

/**
 * Attach Form To Entity
 */
export const glacierPolicyFormsApiAttachFormToEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToEntityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Detach Form From Entity
 */
export const glacierPolicyFormsApiDetachFormFromEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromEntityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/detach-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Entity Attached Forms
 */
export const glacierPolicyFormsApiGetEntityAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetEntityAttachedFormsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetEntityAttachedFormsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/',
    ...options,
  });

/**
 * Get Entity Available Endorsements
 */
export const glacierPolicyFormsApiGetEntityAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/available-endorsements/',
    ...options,
  });

/**
 * Render Form
 *
 * Render a form to PDF
 *
 * If a sequence_id is provided here outside of time travel mode,
 * it will load the policy version from the repository.
 */
export const glacierPolicyFormsApiRenderForm = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiRenderFormData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiRenderFormResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/render-form/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Questions By Policy
 */
export const glacierPolicyFormsApiGetQuestionsByPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/',
    ...options,
  });

/**
 * Post Save Questions Answers Policy
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Questions By Dentist
 */
export const glacierPolicyFormsApiGetQuestionsByDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
  });

/**
 * Post Save Questions Answers Dentist
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Questions By Location
 */
export const glacierPolicyFormsApiGetQuestionsByLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetQuestionsByLocationData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
  });

/**
 * Post Save Questions Answers Location
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Questions By Entity
 */
export const glacierPolicyFormsApiGetQuestionsByEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
  });

/**
 * Post Save Questions Answers Entity
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Binding Conditions
 */
export const glacierPolicyConditionsApiListBindingConditions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiListBindingConditionsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyConditionsApiListBindingConditionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/binding-conditions/',
    ...options,
  });

/**
 * Create Binding Condition
 */
export const glacierPolicyConditionsApiCreateBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiCreateBindingConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyConditionsApiCreateBindingConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/binding-conditions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Binding Condition
 */
export const glacierPolicyConditionsApiDeleteBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiDeleteBindingConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).delete<
    GlacierPolicyConditionsApiDeleteBindingConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/',
    ...options,
  });

/**
 * Update Binding Condition
 */
export const glacierPolicyConditionsApiUpdateBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiUpdateBindingConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyConditionsApiUpdateBindingConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Terms Conditions
 */
export const glacierPolicyConditionsApiListTermsConditions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiListTermsConditionsData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GlacierPolicyConditionsApiListTermsConditionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/terms-conditions/',
    ...options,
  });

/**
 * Create Terms Condition
 */
export const glacierPolicyConditionsApiCreateTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiCreateTermsConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).post<
    GlacierPolicyConditionsApiCreateTermsConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/terms-conditions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Terms Condition
 */
export const glacierPolicyConditionsApiDeleteTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiDeleteTermsConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).delete<
    GlacierPolicyConditionsApiDeleteTermsConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/',
    ...options,
  });

/**
 * Update Terms Condition
 */
export const glacierPolicyConditionsApiUpdateTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiUpdateTermsConditionData,
    ThrowOnError
  >
) =>
  (options.client ?? client).patch<
    GlacierPolicyConditionsApiUpdateTermsConditionResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Erp Eligible Dates
 *
 * Return Valid Effective Dates for ERP (Extended Reporting Period)
 */
export const glacierPolicyErpApiGetErpEligibleDates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyErpApiGetErpEligibleDatesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{policy_id}/erp/eligible-dates',
    ...options,
  });

/**
 * Get Erp Sections
 *
 * Returns an array of ErpSection objects for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiGetErpSections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiGetErpSectionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierPolicyErpApiGetErpSectionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{policy_id}/erp/sections',
    ...options,
  });

/**
 * Start Erp Endorsement
 *
 * Start ERP Endorsement Transaction
 */
export const glacierPolicyErpApiStartErpEndorsement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiStartErpEndorsementData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyErpApiStartErpEndorsementResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{policy_id}/erp/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save Erp Selections
 *
 * Save ERP selections for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiSaveErpSelections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiSaveErpSelectionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyErpApiSaveErpSelectionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{policy_id}/erp/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Copy Policy Endpoint
 *
 * Copy a quote into a new quote via the clone engine.
 *
 * ``@read_only_operation``: copying reads the source account (the new
 * policy is a separate aggregate), so tenancy uses read scope --
 * underwriters may copy any policy they can access while agents stay
 * limited to their own agency (403 cross-agency, enforced by
 * ``AuthenticateAndAccessAccountPermission``).
 */
export const glacierPolicyCloneApiCopyPolicyEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyCloneApiCopyPolicyEndpointData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierPolicyCloneApiCopyPolicyEndpointResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/policy/{account_id}/copy/',
    ...options,
  });

/**
 * Get Jwt Token
 *
 * OneSchema requires use of JWT tokens for requests. This returns a token that
 * the frontend can use when initializing the Importer.
 *
 * https://docs.oneschema.co/docs/generating-jwts
 */
export const glacierOneschemaApiGetJwtToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierOneschemaApiGetJwtTokenData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierOneschemaApiGetJwtTokenResponses,
    GlacierOneschemaApiGetJwtTokenErrors,
    ThrowOnError
  >({ url: '/api/v1/bulk/token/', ...options });

/**
 * Bulk Upload Policies
 */
export const glacierOneschemaApiBulkUploadPolicies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadPoliciesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierOneschemaApiBulkUploadPoliciesResponses,
    GlacierOneschemaApiBulkUploadPoliciesErrors,
    ThrowOnError
  >({
    url: '/api/v1/bulk/policies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Upload Dentists
 *
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadDentists = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadDentistsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierOneschemaApiBulkUploadDentistsResponses,
    GlacierOneschemaApiBulkUploadDentistsErrors,
    ThrowOnError
  >({
    url: '/api/v1/bulk/dentists/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Upload Locations
 *
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadLocationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierOneschemaApiBulkUploadLocationsResponses,
    GlacierOneschemaApiBulkUploadLocationsErrors,
    ThrowOnError
  >({
    url: '/api/v1/bulk/locations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Writing Company
 *
 * List writing company details
 */
export const glacierAgenciesApiListWritingCompany = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierAgenciesApiListWritingCompanyData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierAgenciesApiListWritingCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/writing-company/',
    ...options,
  });

/**
 * Validate Agency
 *
 * Validate the agency.
 */
export const glacierNewGradApiValidateAgency = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiValidateAgencyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiValidateAgencyResponses,
    GlacierNewGradApiValidateAgencyErrors,
    ThrowOnError
  >({
    url: '/api/v1/new-grad/validate-agency',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Validate Association Code
 */
export const glacierNewGradApiValidateAssociationCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiValidateAssociationCodeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiValidateAssociationCodeResponses,
    GlacierNewGradApiValidateAssociationCodeErrors,
    ThrowOnError
  >({
    url: '/api/v1/new-grad/validate-association-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save Answers
 *
 * Save the answers.
 */
export const glacierNewGradApiSaveAnswers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiSaveAnswersData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiSaveAnswersResponses,
    GlacierNewGradApiSaveAnswersErrors,
    ThrowOnError
  >({
    url: '/api/v1/new-grad/answers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Issue Policy
 *
 * Handles the issuance of a new policy for a specified account.
 */
export const glacierNewGradApiIssuePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiIssuePolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiIssuePolicyResponses,
    GlacierNewGradApiIssuePolicyErrors,
    ThrowOnError
  >({ url: '/api/v1/new-grad/{account_id}/issue', ...options });

/**
 * Get Answers
 *
 * Get the answers.
 */
export const glacierNewGradApiGetAnswers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiGetAnswersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierNewGradApiGetAnswersResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/new-grad/answers/{account_id}', ...options });

/**
 * Poll Payment
 *
 * Poll the payment status.
 */
export const glacierNewGradApiPollPayment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiPollPaymentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiPollPaymentResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/new-grad/{account_id}/poll', ...options });

/**
 * Download Quote
 *
 * Download the quote.
 */
export const glacierNewGradApiDownloadQuote = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiDownloadQuoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiDownloadQuoteResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/new-grad/{account_id}/quote', ...options });

/**
 * Download Policy
 *
 * Download the policy.
 */
export const glacierNewGradApiDownloadPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiDownloadPolicyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiDownloadPolicyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/new-grad/{account_id}/policy', ...options });

/**
 * Mark Payment As Paid
 *
 * Mark the payment as paid by updating the paid_at timestamp.
 * This will trigger the policy issuance process via the PaymentResponse signal handler.
 */
export const glacierNewGradApiMarkPaymentAsPaid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiMarkPaymentAsPaidData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierNewGradApiMarkPaymentAsPaidResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/v1/new-grad/{account_id}/mark-as-paid', ...options });

/**
 * Mfa Verify
 *
 * Complete the email-OTP MFA challenge for the headless (SPA) login flow.
 *
 * Compares the submitted ``body.token`` against the cached OTP for
 * ``body.user_id``. On a match the token is consumed, the user is logged in,
 * and the shared ``mfa_verified`` cookie is minted so every surface treats
 * MFA as satisfied. Rate-limited per IP and per ``user_id`` (see the
 * ``throttle`` decorator) to bound brute-force of the OTP.
 *
 * Args:
 * request: The incoming request; the user is anonymous until the OTP
 * matches, at which point ``adapter.login`` establishes the session.
 * body: Validated payload carrying the 6-digit ``token`` and target
 * ``user_id``.
 *
 * Returns:
 * A ``CustomJsonResponse`` with HTTP 200 and a success message when the
 * OTP is valid; otherwise HTTP 400 with ``"Invalid or expired token"``
 * (bad/expired token) or ``"User not found"`` (unknown ``user_id``).
 */
export const glacierAuthenticationApiMfaVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierAuthenticationApiMfaVerifyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierAuthenticationApiMfaVerifyResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/v1/auth/mfa_verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assistant Config
 */
export const glacierAssistantApiAssistantConfig = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierAssistantApiAssistantConfigData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierAssistantApiAssistantConfigResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/assistant/config',
    ...options,
  });

/**
 * Chat
 */
export const glacierAssistantApiChat = <ThrowOnError extends boolean = false>(
  options: Options<GlacierAssistantApiChatData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierAssistantApiChatResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/assistant/chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Submit Feedback
 */
export const glacierAssistantApiSubmitFeedback = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierAssistantApiSubmitFeedbackData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierAssistantApiSubmitFeedbackResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/assistant/{interaction_id}/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Ofac Review
 *
 * The review queue, or one policy's entities; the run summary is for reviewers only.
 */
export const glacierOfacApiOfacReview = <ThrowOnError extends boolean = false>(
  options?: Options<GlacierOfacApiOfacReviewData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierOfacApiOfacReviewResponses,
    GlacierOfacApiOfacReviewErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/ofac/review',
    ...options,
  });

/**
 * Ofac Entity Detail
 *
 * One entity's submitted details, current candidates and decision history.
 */
export const glacierOfacApiOfacEntityDetail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOfacApiOfacEntityDetailData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GlacierOfacApiOfacEntityDetailResponses,
    GlacierOfacApiOfacEntityDetailErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/ofac/policies/{policy_id}/entities/{entity_id}',
    ...options,
  });

/**
 * Ofac Decide
 *
 * Record a reviewer's clear, confirm or reopen, if the entity's status allows it.
 */
export const glacierOfacApiOfacDecide = <ThrowOnError extends boolean = false>(
  options: Options<GlacierOfacApiOfacDecideData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierOfacApiOfacDecideResponses,
    GlacierOfacApiOfacDecideErrors,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/ofac/policies/{policy_id}/entities/{entity_id}/decisions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Reports
 *
 * Return the reports and the agencies that the user can see. It does not call Looker.
 */
export const glacierReportsApiListReports = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierReportsApiListReportsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GlacierReportsApiListReportsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/reports/',
    ...options,
  });

/**
 * Preview Report
 *
 * Return the first rows of the report for the filters of the user.
 */
export const glacierReportsApiPreviewReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierReportsApiPreviewReportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierReportsApiPreviewReportResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/reports/{key}/preview/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Report
 *
 * Return a CSV or XLSX file with all the rows, the selected columns, and the required
 * columns.
 */
export const glacierReportsApiDownloadReport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierReportsApiDownloadReportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GlacierReportsApiDownloadReportResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        in: 'cookie',
        name: 'sessionid',
        type: 'apiKey',
      },
    ],
    url: '/api/v1/reports/{key}/download/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
